// extracted by mini-css-extract-plugin
module.exports = {"GistPreview":"GistPreview_GistPreview__2XmhC"};